import React, { useState, useEffect } from 'react';
 
import {
  fetchpendingsubmissionCandidates,
  restoreCandidate,
  softDeleteCandidate
} from '../../services/user/api';
import { RotateCcw, Trash2 , Search } from 'lucide-react';
 
import '../../styles/user/pendingSubmission.css';
 
const PendingSubmissionPage = () => {
  const [candidates, setCandidates] = useState([]);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(true);
 
  const [modal, setModal] = useState({ visible: false, type: '', message: '', action: null });
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
 
  useEffect(() => {
    loadCandidates();
  }, [currentPage, entriesPerPage]);
 
  const loadCandidates = () => {
    setLoading(true);
    fetchpendingsubmissionCandidates(currentPage, entriesPerPage)
      .then((res) => {
        const data = res.data?.data;
        if (data) {
          setCandidates(data.content || []);
          setTotalElements(data.totalElements || 0);
        }
      })
      .catch((err) => console.error('Error fetching candidates:', err))
      .finally(() => setLoading(false));
  };
 
  const confirmAction = (type, candidateId) => {
    setSelectedCandidateId(candidateId);
    const message =
      type === 'restore'
        ? 'Are you sure you want to extend this candidate\'s login period?'
        : 'Are you sure you want to delete this candidate?';
 
    setModal({
      visible: true,
      type,
      message,
      action: () => (type === 'restore' ? handleRestore(candidateId) : handleSoftDelete(candidateId))
    });
  };
 
  const handleRestore = async (candidateId) => {
    try {
      const res = await restoreCandidate(candidateId);
      setModal({
        visible: true,
        type: 'message',
        message: res.data?.message || 'Login period extended and email sent.',
        action: null
      });
      loadCandidates();
    } catch (error) {
      setModal({
        visible: true,
        type: 'message',
        message: 'Failed to restore candidate.',
        action: null
      });
    }
  };
 
  const handleSoftDelete = async (candidateId) => {
    try {
      await softDeleteCandidate(candidateId);
 
      // Remove candidate from the state directly
      setCandidates((prev) => prev.filter((c) => c.candidateid !== candidateId));
 
      setModal({
        visible: true,
        type: 'message',
        message: 'Candidate deleted successfully.',
        action: null
      });
 
    } catch (error) {
      setModal({
        visible: true,
        type: 'message',
        message: 'Failed to delete candidate.',
        action: null
      });
    }
  };
 
  const closeModal = () => {
    setModal({ visible: false, type: '', message: '', action: null });
    setSelectedCandidateId(null);
  };
 
  const filtered = candidates.filter((c) =>
    c.fullname?.toLowerCase().includes(search.toLowerCase())
  );
  const totalPages = Math.ceil(totalElements / entriesPerPage);
 
  return (
<>
<p className="client-header">Pending Submission Candidates</p>
 
    <div className="client-wrapper">
 
      {/* Modal */}
      {modal.visible && (
<div className="modal-overlay">
<div className="modal-contentt">
<p>{modal.message}</p>
            {modal.action ? (
<div className="modal-actions">
<button className="modal-btn confirm" onClick={() => { modal.action(); closeModal(); }}>Yes</button>
<button className="modal-btn cancel" onClick={closeModal}>No</button>
</div>
            ) : (
<div className="modal-actions">
<button className="modal-btn ok" onClick={closeModal}>OK</button>
</div>
            )}
</div>
</div>
      )}
 
      <div className="clinet-table-controls">
<div className="entries-select">
          Show{' '}
<select
            value={entriesPerPage}
            onChange={(e) => {
              setEntriesPerPage(Number(e.target.value));
              setCurrentPage(0);
            }}
>
<option value="10">10</option>
<option value="25">25</option>
<option value="50">50</option>
</select>{' '}
          entries
</div>
 
<div className="client-search-box">
  {/* <label htmlFor="client-search-input">Search:</label> */}
<div className="client-search-input-wrapper">
<input
      id="client-search-input"
      type="text"
      value={search}
      onChange={(e) => {
        setSearch(e.target.value);
        setCurrentPage(0);
      }}
      placeholder="Search by name"
    />
<Search className="client-search-icon" size={18} />
</div>
</div>
 
      </div>
 
      <div className="clinet-table-container">
        {loading ? (
<div className="loading">Loading candidates...</div>
        ) : (
<clinet-table className="candidates-clinet-table">
<thead>
<tr>
<th>Unique ID</th>
<th>Name</th>
<th>Email</th>
<th>Mobile Number</th>
<th>DOB</th>
<th>Case Initiated Date</th>
<th>Case Initiated Time</th>
<th>Actions</th>
</tr>
</thead>
<tbody>
              {filtered.length > 0 ? (
                filtered.map((candidate) => (
<tr key={candidate.candidateid}>
<td>{candidate.candidateid}</td>
<td>{candidate.fullname}</td>
<td>{candidate.email}</td>
<td>{candidate.mobileNumber}</td>
<td>{candidate.dateOfBirth}</td>
<td>{candidate.caseInitiatedDateOnly}</td>
<td>{candidate.caseInitiatedTimeOnly}</td>
<td>
<span
    className="action-icon recycle"
    title="Restore Login"
    style={{ color: '#6b21a8', cursor: 'pointer' }}
    onClick={() => confirmAction('restore', candidate.candidateid)}
>
<RotateCcw size={20} />
</span>
<span
    className="action-icon delete"
    title="Delete"
    style={{ color: '#dc2626', cursor: 'pointer', marginLeft: '12px' }}
    onClick={() => confirmAction('delete', candidate.candidateid)}
>
<Trash2 size={20} />
</span>
</td>
</tr>
                ))
              ) : (
<tr>
<td colSpan="8" className="no-data">No matching candidates found.</td>
</tr>
              )}
</tbody>
</clinet-table>
        )}
      </div>

  <div className="pagination">
  {totalElements > 0 && (
    <div className="pagination-summary">
      Showing {currentPage * entriesPerPage + 1} to{' '}
      {Math.min((currentPage + 1) * entriesPerPage, totalElements)} of {totalElements} entries
    </div>
  )}

  {totalPages > 1 && (
    <div className="pagination-buttons-user">
      <button
        className="page-btn"
        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
        disabled={currentPage === 0}
>
        ←
      </button>

      <button
        className={`page-btn ${'active'}`}
        onClick={() => setCurrentPage(currentPage)}
>
        {currentPage + 1}
      </button>

      {currentPage + 1 < totalPages && (
<button
          className="page-btn"
          onClick={() => setCurrentPage(currentPage + 1)}
>
          {currentPage + 2}
</button>
      )}
 
      <button
        className="page-btn"
        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1))}
        disabled={currentPage === totalPages - 1}
>
        →
      </button>
    </div>
  )}
</div>



    </div>
</>
  );
};
 
export default PendingSubmissionPage;